import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { invalidateAiListeningPromptData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'
import { PromptStatus } from 'src/services/aiListeningApi/brandProfile.types'

interface UpdateVariables {
  promptId: string
  status: PromptStatus
}

const SUCCESS_MESSAGES: Record<PromptStatus, string> = {
  active: 'Prompt is being tracked again',
  completed: 'Prompt marked as completed',
  draft: 'Prompt moved to draft',
}

export const useUpdateAiListeningPromptStatusMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ promptId, status }: UpdateVariables) =>
      AiListeningBrandProfileApiService.updatePromptStatus(promptId, status),
    onError: (error: AxiosError<AiListeningErrorEnvelope>) => {
      toast.error(error.response?.data?.error || 'Failed to update the prompt')
    },
    onSuccess: (_data, { promptId, status }) => {
      invalidateAiListeningPromptData(queryClient, promptId)
      toast.success(SUCCESS_MESSAGES[status])
    },
  })
}
